interface StarshineHeaderProps {
  message: string
}


export function StarshineHeader(props: StarshineHeaderProps) {
  return <div className='starshine-header'>
    <h2>{props.message}</h2>
  </div>
}